import { memo, useEffect } from 'react'
import Flag from 'react-country-flag'
import styled from 'styled-components'
import useBasic from '@/hooks/use-basic'
import { breakpoints, transitions, colors, fontSizes } from '@/styles'
import toArray from '@/utils/to-array'
import Icon from '@/components/icon'
import { show as showCountrySelectModal } from './country-select-modal'

const CountrySelect = styled.button.attrs({ type: 'button' })`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 50px;
  font-size: ${fontSizes.regular};
  color: ${colors.black};
  background: none;
  min-width: ${({ showFlag }) => (showFlag ? '84px' : '70px')};
  border: none;
  padding: 0;
  border-right-width: 1.5px;
  border-right-style: solid;
  padding: 0 8px;
  border-right-color: var(--border-color);
  transition: ${transitions.borderColor};
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  ${props =>
    props.size === 'medium' &&
    `
    height: 46px;
    font-size: 14px;
  `}
  ${props =>
    props.size === 'responsive' &&
    `
    height: 46px;
    font-size: 14px;
    @media only screen and (max-width: ${breakpoints.ipadMiniMax}) {
      height: 50px;
      font-size: ${fontSizes.regular};
    }
  `}
`

const Code = styled.span`
  flex: 1;
  padding-right: 8px;
`

const flagStyle = {
  marginRight: '5px',
  fontSize: '24px',
  width: '24px',
  height: '24px',
  backgroundSize: 'contain'
}

const CountryCodeSelect = ({ value, onChange, disabled, showFlag = true, ...rest }) => {
  const { countries } = useBasic(['countries'])

  useEffect(() => {
    if (!value) {
      onChange({
        target: {
          value: {
            txt_id: 'ca',
            calling_code: '1'
          }
        }
      })
    }
  }, [onChange, value])

  const handleChangeCountryCode = () => {
    showCountrySelectModal({
      countries: toArray(countries),
      onSelect: onChange,
      currentValue: value.txt_id
    })
  }

  return (
    <CountrySelect
      onClick={handleChangeCountryCode}
      disabled={disabled}
      showFlag={showFlag}
      {...rest}
    >
      {showFlag && <Flag aria-label={value?.name} countryCode={value?.txt_id} style={flagStyle} />}
      <Code>+{value.calling_code}</Code>
      <Icon id="down_arrow_dark" width={8} height={6} />
    </CountrySelect>
  )
}

export default memo(CountryCodeSelect)
